// Copies text to the clipboard, falling back to a hidden textarea +
// execCommand('copy') when the Clipboard API is unavailable or denied
// (e.g. insecure context, permission prompt dismissed). Resolves to a
// boolean so callers can show an accurate "copied" vs "copy failed" toast
// instead of assuming success on an un-awaited promise.
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(textarea);
      return ok;
    } catch {
      return false;
    }
  }
}
